import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import AdtaDeviceOverviewContextProvider from "./context/AdtaDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ADTA} from "../../util/RouteConstants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AdtaDevicePage extends Component {
    render() {
        return (
            <Column>
                <AdtaDeviceOverviewContextProvider>
                    <TabLayout routes={ADTA} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={ADTA}/>
                </AdtaDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AdtaDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/AdtaDevicePage.js